import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppConfigsService } from '@app/core/services';
import { HandlerService } from '@app/_services/handler.service';

@Component({
    selector: 'app-unsubscribe-email',
    templateUrl: './unsubscribe-email.component.html',
    styleUrls: ['./unsubscribe-email.component.scss']
})
export class UnsubscribeComponent implements OnInit {
    message = 'Вы успешно отписаны от рассылки на почту';

    constructor(
        private activatedRoute: ActivatedRoute,
        private appConfigsService: AppConfigsService,
        private handlerService: HandlerService
    ) {}

    ngOnInit(): void {
        const userId = this.activatedRoute.snapshot.params['user_id'];
        const urlParams = new URLSearchParams(document.location.search);
        const params = {
            notificationType: 'email',
            status: urlParams.get('subscribe_email') === 'false' ? 0 : 1,
            userId: userId
        };

        console.log(params);

        this.appConfigsService.updateNotificationsConfig(params).subscribe(resp => {
            this.handlerService.checkErrors(resp);
            this.message = resp.error ? resp.error : this.message;
        });
    }
}
